(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('infoModal', infoModal);

    /* @ngInject */
    function infoModal() {
        var directive = {
            bindToController: true,
            templateUrl: 'info-modal.tpl',
            controller: infoModalController,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            setTimeout(scope.$root.modalClose, 1100);
        }
    }

    /* @ngInject */
    function infoModalController ($scope) {
    }
})();